const earningsDrilldownIT = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtri",
                "monthRange": "Intervallo di Mesi",
                "startingMonth": "Mese di Inizio",
                "endingMonth": "Mese di Fine",
                "label": "Etichetta",
                "store": "Negozio",
                "release": "Pubblicazione",
                "track": "Traccia",
                "country": "Paese",
                "subuser": "Sottoutente",
                "fetchingEarnings": "Recupero delle statistiche sui guadagni dal database"
            },
            "button": {
                "generateReport": "Genera Report",
                "resetFilters": "Reimposta Filtri"
            },
            "options": {
                "store": {
                    "selectStore": "Seleziona Negozio",
                    "allStores": "Tutti i Negozi"
                },
                "label": {
                    "selectLabel": "Seleziona Etichetta"
                },
                "country": {
                    "allCountries": "Tutti i Paesi"
                },
                "release": {
                    "allReleases": "Tutte le Pubblicazioni"
                },
                "track": {
                    "allTracks": "Tutte le Tracce"
                },
                "subuser": {
                    "selectSubuser": "Seleziona Sottoutente"
                },
                "period": {
                    "selectMonthRange": "Seleziona Intervallo di Mesi",
                    "last3Reports": "Ultimi 3 Rapporti",
                    "last6Reports": "Ultimi 6 Rapporti",
                    "last12Reports": "Ultimi 12 Rapporti",
                    "custom": "Personalizzato"
                }
            },
            "validation": {
                "monthRangeRequired": "* Il filtro Intervallo di Mesi è obbligatorio",
                "labelRequired": "* Il filtro Etichetta è obbligatorio"
            }
        },
        "royaltiesSummary": {
            "title": "Riepilogo Royalties",
            "subtitle": "Panoramica dell'Intervallo di Mesi selezionato",
            "label": {
                "monthRangeText": "Ultimi 12 Estratti Conto",
                "revenueEUR": "Entrate (€)",
                "combinedRevenue": "Entrate Combinate",
                "combinedRevenueEUR": "Entrate Combinate (€)",
                "otherStores": "Altri Negozi"
            }
        },
        "storeWiseRevenuePercentage": {
            "title": "Percentuale di Entrate per Negozio"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Ripartizione delle Entrate per Negozio",
            "label": {
                "revenue": "Entrate"
            }
        },
        "revenueByTerritory": {
            "title": "Entrate per Territorio"
        },
        "top5Releases": {
            "title": "Top 5 Pubblicazioni",
            "table": {
                "column": {
                    "releaseName": "Nome Pubblicazione",
                    "revenue": "Entrate"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 Tracce",
            "table": {
                "column": {
                    "trackName": "Nome Traccia",
                    "revenue": "Entrate"
                }
            }
        },
        "message": {
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "subscriptionUpgrade": "Il tuo attuale piano di abbonamento non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione."
        }
    }
};

export default earningsDrilldownIT;